import { AuthProvider, useAuth } from './lib/AuthContext';
import AuthPage from './components/AuthPage';
import RestockManager from './components/RestockManager';
import { RefreshCw } from 'lucide-react';
import './index.css'

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <div className="text-center">
          <RefreshCw className="w-8 h-8 animate-spin mx-auto mb-4 text-blue-400" />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) return <AuthPage />;
  return <RestockManager />;
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
